/* YoClay — scroll infinito da coleção: revela N cards por carga e busca a próxima página (section rendering) quando o buffer acaba. */
(function () {
  'use strict';
  function keyOf(card) {
    var k = card.getAttribute('data-yc-key') || (card.querySelector('[data-yc-key]') || {}).getAttribute && card.querySelector('[data-yc-key]').getAttribute('data-yc-key');
    if (k) return k;
    var a = card.querySelector('a[href*="/products/"]');
    if (!a) return null;
    try { return new URL(a.getAttribute('href'), location.origin).pathname.replace(/^.*\/products\//, ''); } catch (e) { return null; }
  }
  function init(grid) {
    if (grid.__ycInit) return;
    grid.__ycInit = true;
    var perLoad = parseInt(grid.getAttribute('data-per-load'), 10) || 16;
    var nextUrl = grid.getAttribute('data-next-url');
    var sectionId = grid.getAttribute('data-section-id');
    var root = grid.closest('.cc-filters-results') || grid.parentNode;
    var sentinel = root.querySelector('[data-yc-sentinel]');
    var loading = root.querySelector('[data-yc-loading]');
    var seen = {};
    var queue = [];
    var busy = false;
    Array.prototype.slice.call(grid.children).forEach(function (card, i) {
      var k = keyOf(card);
      if (k) { if (seen[k]) { card.remove(); return; } seen[k] = true; }
      if (i < perLoad) card.classList.add('yc-shown'); else { card.hidden = true; card.classList.add('yc-shown'); queue.push(card); }
    });
    function reveal() {
      var n = 0;
      while (queue.length && n < perLoad) { queue.shift().hidden = false; n++; }
      return n;
    }
    function fetchNext() {
      if (!nextUrl) return Promise.resolve(false);
      var u = new URL(nextUrl, location.origin);
      if (sectionId) u.searchParams.set('section_id', sectionId);
      if (loading) loading.hidden = false;
      return fetch(u.toString(), { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var g = doc.querySelector('[data-yc-infinite]');
        nextUrl = g ? g.getAttribute('data-next-url') : null;
        if (g) Array.prototype.slice.call(g.children).forEach(function (card) {
          var k = keyOf(card);
          if (k && seen[k]) return;
          if (k) seen[k] = true;
          card.classList.add('yc-shown'); card.hidden = true;
          grid.appendChild(card); queue.push(card);
        });
        return true;
      }).catch(function () { nextUrl = null; return false; }).finally(function () { if (loading) loading.hidden = true; });
    }
    function loadMore() {
      if (busy) return;
      busy = true;
      var fill = function () {
        if (queue.length >= perLoad || !nextUrl) { reveal(); return Promise.resolve(); }
        return fetchNext().then(fill);
      };
      fill().then(function () {
        busy = false;
        document.dispatchEvent(new CustomEvent('yc:infinite:loaded', { detail: { grid: grid } }));
        if (!queue.length && !nextUrl) { if (io) io.disconnect(); if (sentinel) sentinel.remove(); return; }
        if (sentinel && sentinel.getBoundingClientRect().top < window.innerHeight + 600) loadMore();
      });
    }
    var io = null;
    if (!sentinel || !('IntersectionObserver' in window)) return;
    io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) loadMore(); }, { rootMargin: '600px 0px' });
    io.observe(sentinel);
    if (!queue.length && !nextUrl) { io.disconnect(); sentinel.remove(); }
    else if (queue.length < perLoad && nextUrl) { /* primeira carga incompleta (muitos ocultos): completa já */
      var need = perLoad - grid.querySelectorAll('.yc-shown:not([hidden])').length;
      if (need > 0) { busy = true; (function f() { if (queue.length >= need || !nextUrl) { for (var i = 0; i < need && queue.length; i++) queue.shift().hidden = false; busy = false; return; } fetchNext().then(f); })(); }
    }
  }
  function scan() { document.querySelectorAll('[data-yc-infinite]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
})();
